<template>
    <div class="w-full">

    <ds-table
        :data="landingsData"
        :heads="heads"
        :paginate="false"
        spacer
        :max-items="landingsData.length"
    >
        <template v-slot:id="{id}">
                <p class="product-name font-medium truncate flex items-center" style="height: 38px;">{{id.id}}</p>
        </template>

        <template v-slot:name="{name}">
            <div class="flex items-center">
                <vs-button :disabled="!name.preview_url" target="_blank" :href="name.preview_url" radius color="primary" type="flat" v-bind="$iconData('icon-eye', 'fi-rr-eye')"></vs-button>
                <p class="product-name font-medium truncate ml-2">{{name.name}}</p>
            </div>
        </template>
    </ds-table>
</div>
</template>

<script>
import i18n from '@/i18n/i18n'

export default {
    props: {
        landingsData: {
            type: Array,
            require: true
        }
    },

    data() {
        return {
            heads: [
                {name: 'global.id', key: 'id', sortKey: 'id', value: 'id', display: true, width: '40px'},
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Language', key: 'language', value: 'language', display: true}
            ]
        }
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        }
    }
}
</script>
